import {
	CheckCircleOutlined, CheckCircleFilled, MinusOutlined, CloseCircleOutlined
} from '@ant-design/icons';
import { Role } from '../../features/user/Permission';

export const SOURCE_INTERNAL = 'Internal';
export const SOURCE_SHERLOCK = 'DBC';

export const KitType = {
	UNIVERSAL_KIT: "U",
	KIT: "K",
	Y_CABLE_KIT: "Y",
	ADDITIONAL: "A"
}

export const SupportedFlag = {
	UNKNOWN: 1,
	SUPPORTED: 2,
	NOT_SUPPORTED: 3
}

export const VehicleModelFormItem = (t) => [
	{
		name: 'make',
		label: t('VehicleModel.Make'),
		rules: [
			{
				required: true,
				message: t('ValidationErrors.MakeRequired')
			},
			{
				pattern: new RegExp(/^[^!@#$%^&*()_+=\-[\]{}|\\:;"'<>,.?/~` ]/),
				message: t('ValidationErrors.InvalidMakeFormat')
			}
		]
	},
	{
		name: 'model',
		label: t('VehicleModel.Model'),
		rules: [
			{
				required: true,
				message: t('ValidationErrors.ModelRequired')
			},
			{
				pattern: new RegExp(/^[^!@#$%^&*()_+=\-[\]{}|\\:;"'<>,.?/~` ]/),
				message: t('ValidationErrors.InvalidModelFormat')
			}
		]
	},
	{
		name: 'yearOfManufacture',
		label: t('VehicleModel.Year'),
		rules: [
			{
				required: true,
				message: t('ValidationErrors.YearRequired')
			},
			{
				pattern: new RegExp(/^[1-9]\d*$/),
				message: t('ValidationErrors.InvalidManufactureYearFormat')
			}
		]
	}
];

export const PATHS = {
	VEHICLE_COMPATIBILITY_DEFAULT: '/vehicleCompatibilitySearch',
	VEHICLE_COMPATIBILITY: '/vehicleCompatibility',
	VEHICLE_MODEL: '/vehicleModel',
	VEHICLE_MODEL_GROUP: '/vehicleModelGroup'
};

export const getStatusConfig = (r) => {
	let config = {
		VERIFIED: {
			label: 'VehicleModel.SupportedAndVerified',
			icon: CheckCircleFilled,
			color: '#52C41A', // green
			nextStatus: "N",
			status:"V"
		},
		NOT_SUPPORTED: {
			label: 'VehicleModel.NotSupported',
			icon: CloseCircleOutlined,
			color: '#FFA39E', // red
			nextStatus: "U",
			status:"N"
		},
		UNKNOWN: {
			label: 'VehicleModel.Unknown',
			icon: MinusOutlined,
			color: '#9FA9B7',
			status:"X",
			nextStatus: "U",
		}
	}
	
	/**
	 * for internal case, Measurements will remain unknown even until VCM send us the measurement. 
	 * All bus type predefined measurement is not considered as support even VCM tell us the bus type without measurement
	 * for other case, it will be default supported and VCM is to tell us whether it is verified or not
	 **/
	if (r?.source?.toLowerCase() === "internal") {
		if (r?.pidVerificationStatus) {
			config = {
				...config, ...{
					SUPPORTED: {
						label: 'VehicleModel.NotSupported',
						icon: CloseCircleOutlined,
						color: '#FFA39E', // red
						nextStatus: "V",
						status:"U"
					}
				}
			}
			config.NOT_SUPPORTED.nextStatus = 'V';
		}
		else {
			config = {
				...config, ...{
					SUPPORTED: {
						label: 'VehicleModel.Unknown',
						icon: MinusOutlined,
						color: '#9FA9B7',
						nextStatus: "V",
						status:"U"
					},
					UNKNOWN: {
						label: 'VehicleModel.Unknown',
						icon: MinusOutlined,
						color: '#9FA9B7',
						status:"X",
						nextStatus: "V"
					}
				}
			}
		}
	}
	else {
		config = {
			...config, ...{
				SUPPORTED: {
					label: 'VehicleModel.Supported',
					icon: CheckCircleOutlined,
					color: '#52C41A',
					nextStatus: "V",
					status:"U"
				}
			}
		}
	}

	return config;
};

export const STATUS_KEY_MAP = {
  'V': 'VERIFIED',
  'U': 'SUPPORTED',
  'N': 'NOT_SUPPORTED',
  'P': 'PARTIALLY_SUPPORTED',
  'X': 'UNKNOWN'
};

export const BUS_TYPES = {
  DEFAULT: 'DEFAULT',
  OBDII: 'OBDII',
  J1939: 'J1939',
  J1708: 'J1708',
  INVENTURE: 'INVENTURE',
}

export const TOTAL_DISTANCE_IDENTIFIER = 'Cod';
export const TOTAL_FUEL_IDENTIFIER = 'Cfc';
export const ENGINE_HOURS_IDENTIFIER = 'Che';

export const FeatureMeasurementTable = {
	"IdleOrWorkVsIdle":[["Cse"],["Csw"],["Che"]],
	"OverRevving":[["Cse"]],
	"OverSpeeding":[["Csw"]],
	"HighEngineOilTemperature":[["Cto"]],
	"HighEngineCoolantTemperature":[["Ctc"]],
	"LowEngineOilPressure":[["Cpo"]],
	"HarshAccAndBraking":[["Csw"]],
	"MaintenanceSchedule":[["Cse"],["Che"]],
	"DrivingWithoutSeatBeltAlerting":[["Csw"], ["Cb1"]],
	"DriverScorecard":[["Cse"],["Csw"],["Cod", "Csw"],["Cfc","Cfh","Cfr","Ccf"]],
	"BrakeCount":[["Ckk"]],
	"FaultCodes":[["Dtc"]],
	"FuelTaxCredit":[["Cse"],["Csw"],["Cfc", "Cfh","Cfr","Ccf"],["Cod","Csw"]],
	"PtoUtilization":[["Csw"],["Cse"],["Cvp"]],
	"Co2Emission":[["Cfc", "Cfh", "Cfr","Ccf"]]
}

export const CALCULATABLE_MEASUREMENTS = {
  [TOTAL_DISTANCE_IDENTIFIER]: ['Csw'],
  [TOTAL_FUEL_IDENTIFIER]: ['Cfr', 'Cva', 'Ccf']
}